import { HashLink } from 'react-router-hash-link';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero__title">
        <span className="hero__h1--ot">&lt;h1&gt;</span>
        <h1>juan casals</h1>
        <span className="hero__h1--ct">&lt;/h1&gt;</span>
      </div>

      <div className="hero__subtitle">
        <span className="hero__p--ot">&lt;p&gt;</span>
        <p>Junior Front End Developer</p>
        <span className="hero__p--ct">&lt;/p&gt;</span>
      </div>

      <div className="hero__contact">
        <HashLink className="button-big" to="/#contact" smooth="true">
          CONTACT ME
        </HashLink>
      </div>
    </section>
  );
};

export default Hero;
